const colors = {
  // primary: "#eb6e34ff",
  primary : "#ffffffff",
  secondary: "#eb6e34ff",
  background: "#f5821f",  
  navbar: "#de6d0a",
  textPrimary: "#fff",
  textSecondary: "#fff",
  save: "green",
  survey: "#000000b3",
  // sidebarText:"#ffffffff",
  sidebarText:"#eb6e34ff",
  button:"#ed6222ff",
  navbarText: "#0f2944",
  buttoSecondary:"#b9976e",
  textColor : "#27253e ",
  green : "#123924ff",
};

export default colors;
